import type { FooterButtonProps } from './FooterButton.types';

import React from 'react';
import { useHotkeys } from 'react-hotkeys-hook';
import classNames from 'classnames';
import * as constants from './FooterButton.constants';
import './_footer-button.scss';

export const FooterButton = ({ type, onClick, isDisabled, isHotkeyDisabled }: FooterButtonProps) => {
  useHotkeys(
    constants.FOOTER_BUTTON_HOTKEYS[type],
    () => onClick?.(),
    {
      preventDefault: true,
      enabled: !isDisabled && !isHotkeyDisabled,
      enableOnFormTags: true,
    },
    [onClick],
  );

  return (
    
    <button
      className={classNames({ 
        'footer-button': true,
        'footer-button__prev': type === 'prev',
        'footer-button__next': type === 'next',
        'footer-button__report': type === 'report',
        'footer-button__navigator': type === 'navigator' || type === 'review_screen',
        'footer-button__end':
          type === 'end_exam' || type === 'end_section' || type === 'end_review' || type === 'return_overview',
        'footer-button__review-all': type === 'review_all',
        'footer-button__review-incomplete': type === 'review_incomplete',
        'footer-button__review-flagged': type === 'review_flagged',
      })}
      onClick={onClick}
      disabled={isDisabled}
      dangerouslySetInnerHTML={{ __html: constants.FOOTER_BUTTON_HTMLS[type] }}
    ></button>
  );
};
